import { Card, Empty, Input, Menu, Row, Select, Typography } from "antd";
import { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import HTTPClient from "../../utils/HTTPClient";
import { CategoryAppList } from "./CategoryAppList";
import useDarkMode from "../../hooks/useDarkMode";
import { useTranslation } from "react-i18next";

export default function StoreApp({}) {
    const [categories, setCategories] = useState([]);
    const [appsResponse, setAppResponse] = useState([]);
    const [current, setCurrent] = useState(null);
    const [search, setSearch] = useState("");
    const [darkMode] = useDarkMode();

    const { t } = useTranslation();

    useEffect(() => {
        HTTPClient.get("/app/_app_typologies").then((res) => {
            let appsByType = {};
            const tmpCategories = [];

            buildCategoriesAndAppsByResponse(res.data, tmpCategories, appsByType);
            buildCategoriesForMenu(tmpCategories, appsByType);

            setAppResponse(res.data);
            setCategories(tmpCategories);
            setCurrent(tmpCategories[0].key);
        });
    }, []);

    useEffect(() => {
        let tmpCategories = [...categories];

        let appsByType = {};
        buildCategoriesAndAppsByResponse(appsResponse, tmpCategories, appsByType);
        const filteredApps = {};

        for (const type in appsByType) {
            const apps = appsByType[type].filter((app) =>
                app.label.toLowerCase().includes(search.toLowerCase())
            );

            if (apps.length > 0) {
                filteredApps[type] = apps;
            }
        }

        buildCategoriesForMenu(tmpCategories, filteredApps);

        tmpCategories = tmpCategories.filter((category) => category.extra.length > 0);
        if (!tmpCategories.length) {
            setCurrent(null);
        } else {
            setCurrent(tmpCategories[0].key);
        }
        setCategories(tmpCategories);
    }, [search]);

    const isLargeScreen = useMediaQuery({
        query: "(min-width: 771px)",
    });

    const handleMenuClick = (item) => {
        setCurrent(item.key);
    };

    const buildCategoriesAndAppsByResponse = (appsResponse, tmpCategories, appsByType) => {
        for (const app of appsResponse) {
            if (!tmpCategories.find((cat) => cat.key === app.type)) {
                tmpCategories.push({
                    key: app.type,
                    label: app.type.charAt(0).toUpperCase() + app.type.slice(1),
                    onClick: () => {
                        setCurrent(app.type);
                    },
                    content: <>{app.type}</>,
                });
            }

            if (!appsByType[app.type]) appsByType[app.type] = [];
            appsByType[app.type].push(app);
        }
    };
    const buildCategoriesForMenu = (tmpCategories, appsByType) => {
        for (const category of tmpCategories) {
            if (!appsByType[category.key]) appsByType[category.key] = [];
            category.content = <CategoryAppList apps={appsByType[category.key]} />;
            category.extra = appsByType[category.key];
        }
    };

    return (
        <Row style={{ padding: isLargeScreen ? "20px 50px" : "10px 10px" }}>
            <Card style={{ width: "100%" }}>
                <Card.Meta
                    title={
                        <Typography.Text
                            style={{
                                fontSize: "x-large",
                                textTransform: "uppercase",
                            }}></Typography.Text>
                    }
                />
                <div
                    style={{
                        position: "sticky",
                        top: 0,
                        paddingTop: "10px",
                        zIndex: 1,
                        backgroundColor: darkMode ? "#141414" : "white",
                        borderRadius: "10px",
                        borderBottomLeftRadius: 0,
                        borderBottomRightRadius: 0,
                    }}>
                    <Input
                        style={{ position: "sticky", top: 0, zIndex: 1 }}
                        size="large"
                        placeholder={t("lista_app.placeholder")}
                        onChange={(e) => setSearch(e.target.value)}
                        value={search}
                    />
                    {categories.length && isLargeScreen ? (
                        <Menu
                            style={{ width: "100%", marginTop: "10px" }}
                            onClick={handleMenuClick}
                            selectedKeys={[current]}
                            mode="horizontal"
                            items={categories}
                        />
                    ) : null}
                    {categories.length && !isLargeScreen ? (
                        <Select
                            onChange={(e) => setCurrent(e)}
                            value={current}
                            size="large"
                            style={{ width: "100%", marginTop: "10px" }}>
                            {categories.map((item) => (
                                <Select.Option key={item.key}>{item.label}</Select.Option>
                            ))}
                        </Select>
                    ) : null}
                </div>

                {!categories.length && <Empty style={{ width: "100%", marginTop: "30px" }} />}
                {categories.length && current
                    ? categories.find((item) => item.key === current)?.content
                    : null}
            </Card>
        </Row>
    );
}
